import React from "react";
var __jsx = React.createElement;
import { useLang } from "@/common/Contexts/LanguageContext";
import { getFormatTime, getLocalizedDate } from "@/utils/common";
import stl from "./ViewOfferedDocuments.module.css";
import LinkToFile from "@/common/HOCs/LinkToFile";
var ViewOfferedDocuments = function ViewOfferedDocuments(_ref) {
  var title = _ref.title,
    offered_documents = _ref.offered_documents,
    hideDate = _ref.hideDate,
    g4_data = _ref.g4_data;
  var lang = useLang();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.offeredDocs
  }, title && /*#__PURE__*/React.createElement("h3", null, title), offered_documents === null || offered_documents === void 0 ? void 0 : offered_documents.map(function (offeredDocument, idx) {
    var localizedDate = {};
    var localizedTime = {};
    if (offeredDocument !== null && offeredDocument !== void 0 && offeredDocument.date_time) {
      localizedDate = getLocalizedDate(new Date(offeredDocument === null || offeredDocument === void 0 ? void 0 : offeredDocument.date_time), lang, true);
      localizedTime = getFormatTime(new Date(offeredDocument === null || offeredDocument === void 0 ? void 0 : offeredDocument.date_time), lang);
    }
    return /*#__PURE__*/React.createElement("div", {
      className: stl.documentContainer,
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      className: stl.headerContainer
    }, /*#__PURE__*/React.createElement("p", null, offeredDocument.name), /*#__PURE__*/React.createElement(LinkToFile, {
      fileUri: offeredDocument === null || offeredDocument === void 0 ? void 0 : offeredDocument.file,
      g4_data: g4_data,
      dbFile: offeredDocument,
      renderFunc: function renderFunc(label, onClick) {
        return /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: stl.download,
          onClick: onClick
        }, label);
      }
    })), (offeredDocument === null || offeredDocument === void 0 ? void 0 : offeredDocument.date_time) && !hideDate && /*#__PURE__*/React.createElement("div", {
      className: stl.timeStamp
    }, /*#__PURE__*/React.createElement("p", null, localizedDate.day, " ", localizedDate.date), /*#__PURE__*/React.createElement("p", null, localizedTime.time, " ", localizedTime.format)));
  })));
};
export default ViewOfferedDocuments;